<template>
    <div id="praise-modal-email-field" class="content">
        <label for="praise-send-email" class="screen-reader-only">
            Field for praise recipients
        </label>
        <InputText
            id="praise-send-email"
            v-model="emails"
            v-tooltip.top="
                'Additional recipients will be CC\'d. Emails must be separated with \',\' or \';\''
            "
            class="input-text"
            :model-value="updateEmailInput(emails)"
            :invalid="isInvalid"
        />

        <small v-if="isInvalid && errorMsg" class="error-msg">
            {{ errorMsg }}
        </small>
    </div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext'
import { ref, computed, onMounted } from 'vue'

type Props = {
    praiseeEmail: string | undefined
    isInvalid: boolean
    errorMsg?: string
}

const props = defineProps<Props>()
const emails = defineModel('emails')

onMounted(() => {
    emails.value = props.praiseeEmail ? props.praiseeEmail + ';' : ''
})

const updateEmailInput = (emails): string => {
    if (emails?.endsWith(' ')) {
        // attempt to write another email
        const cleanEmails = emails.trim()
        if (
            cleanEmails &&
            !cleanEmails.endsWith(';') &&
            !cleanEmails.endsWith(',')
        ) {
            const delimiter = /[;,]/.exec(cleanEmails)?.[0] ?? ';' // find the first delimiter
            return cleanEmails + delimiter + ' ' // append delimiter
        }
    }
    return emails ?? ''
}
</script>

<style scoped lang="less">
@import '@/styles/prime-vue/variables.less';

.content {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.input-text {
    flex: 1;
}

.error-msg {
    color: var(--p-error-600);
}
</style>
